import { requiredString } from '@/common/utils/zod';
import { endOfToday } from 'date-fns';
import { z } from 'zod';

export const addFamilyMembersFormSchema = z.object({
  members: z.array(
    z.object({
      type: z.object({
        label: requiredString,
        value: z.enum([
          'spouse',
          'child',
          'parent',
          'sibling',
          'sibling-in-law',
          'parent-in-law',
          'grandparent',
          'civil-partner',
        ]),
      }),
      fullName: requiredString,
      shortName: z.string().optional(),
      taxId: requiredString,
      birthdate: z
        .date({
          required_error: 'errors.input.invalid_date',
          invalid_type_error: 'errors.input.invalid_date',
        })
        .max(endOfToday(), 'errors.input.invalid_date'),
      gender: z.object({ value: z.enum(['M', 'F']), label: z.string() }),
      error: z.string().nullable().optional(),
      isUserAdded: z.boolean().optional(),
      selected: z.boolean(),
      memberId: z.string().optional(),
      editableFields: z.array(z.string()),
    })
  ),
});

export type TAddFamilyMembersFormValues = z.infer<
  typeof addFamilyMembersFormSchema
>;
